import { render, staticRenderFns } from "./PurchaseSearchWithBrowse.vue?vue&type=template&id=6bbd8ce6"
import script from "./PurchaseSearchWithBrowse.vue?vue&type=script&lang=ts"
export * from "./PurchaseSearchWithBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bbd8ce6')) {
      api.createRecord('6bbd8ce6', component.options)
    } else {
      api.reload('6bbd8ce6', component.options)
    }
    module.hot.accept("./PurchaseSearchWithBrowse.vue?vue&type=template&id=6bbd8ce6", function () {
      api.rerender('6bbd8ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseSearchWithBrowse.vue"
export default component.exports